var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataValue.value < 0)?_c('span',{staticClass:"negative"},[_vm._v(_vm._s(_vm.dataValue.text))]):_c('span',[_vm._v(_vm._s(_vm.dataValue.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }